/**
 * assets/category-mini-grid.js
 * Slider logic for “Category Mini Grid” section.
 * Include once in theme.liquid with:
 *   <script src="{{ 'category-mini-grid.js' | asset_url }}" defer></script>
 *
 * Requires:
 *  - Each slide (.grid-item) inside .collage-slider has data-name="…"
 *  - A <div class="radio-indicators"></div> underneath the slider
 *  - .visually-hidden helper CSS (from previous snippet)
 */

(function() {
  function initCategoryMiniGrid(sectionEl) {
    const slider     = sectionEl.querySelector('.collage-slider');
    const prevBtn    = sectionEl.querySelector('.slider-arrow.prev');
    const nextBtn    = sectionEl.querySelector('.slider-arrow.next');
    const indicators = sectionEl.querySelector('.radio-indicators');
    if (!slider || !prevBtn || !nextBtn || !indicators) return;

    // collect slides
    const slides = Array.from(slider.children);
    if (!slides.length) return;

    // measure one slide and visible capacity
    const slideWidth = slides[0].getBoundingClientRect().width;
    const visibleCount = Math.max(1,
      Math.floor(slider.clientWidth / slideWidth)
    );

    // total pages needed
    const numberOfDots = Math.ceil(slides.length / visibleCount);

    // build dot indicators
    indicators.innerHTML = '';
    for (let page = 0; page < numberOfDots; page++) {
      const wrapper = document.createElement('label');
      wrapper.className = 'radio-wrapper';

      // hidden radio
      const input = document.createElement('input');
      input.type  = 'radio';
      input.name  = `slider-${sectionEl.id}-dots`;
      input.value = page;
      if (page === 0) input.checked = true;

      // click scrolls to the first slide of that page
      input.addEventListener('click', () => {
        const targetIndex = page * visibleCount;
        const targetSlide = slides[Math.min(targetIndex, slides.length-1)];
        slider.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth'
        });
      });

      // screen-reader label: first item in that page
      const firstInPage = slides[page * visibleCount];
      const srLabel = document.createElement('span');
      srLabel.className = 'visually-hidden';
      srLabel.textContent =
        firstInPage?.dataset.name || `Slide ${page + 1}`;

      // visible dot
      const dot = document.createElement('span');
      dot.className = 'radio-dot';

      wrapper.append(input, srLabel, dot);
      indicators.appendChild(wrapper);
    }

    // helper to get all dot inputs
    const dotInputs = () =>
      Array.from(indicators.querySelectorAll('input[type="radio"]'));

    // keep dots in sync on scroll
    function updateIndicator() {
      const scrollLeft = slider.scrollLeft;
      // find page whose start-slide is closest to scrollLeft
      let closest = 0, minDist = Infinity;
      for (let page = 0; page < numberOfDots; page++) {
        const idx = Math.min(page * visibleCount, slides.length - 1);
        const dist = Math.abs(slides[idx].offsetLeft - scrollLeft);
        if (dist < minDist) {
          minDist = dist;
          closest = page;
        }
      }
      dotInputs().forEach((r, i) => r.checked = (i === closest));
    }
    slider.addEventListener('scroll', updateIndicator);

    // arrow click → one “page” by viewport width
    prevBtn.addEventListener('click', () => {
      slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      slider.scrollBy({ left:  slider.clientWidth, behavior: 'smooth' });
    });
  }

  // lazy init with IntersectionObserver
  function lazyInit(sectionEl) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            initCategoryMiniGrid(entry.target);
            obs.disconnect();
          }
        });
      });
      io.observe(sectionEl);
    } else {
      initCategoryMiniGrid(sectionEl);
    }
  }

  window.addEventListener('load', () => {
    document
      .querySelectorAll('[id^="category-mini-slider-"]')
      .forEach(sectionEl => lazyInit(sectionEl));
  });
})();
